

/**
 * @classdesc Un article d'un module
 * @kind class
 * @export
 * @prop {int} id - Id de l'article
 *  @prop {int} id_module - Id du module
 * @prop {string} nom - Nom de l'article
 * @prop {string} description - Description de l'article
 *  @prop {int} prix - Prix de base de l'article
 * @prop {boolean} obligatoire - L'article est obligatoire
 * @prop {datetime} date_max - Date/Heure limite de disponibilité
 * @prop {string} url_image - Url de l'image
 * @prop {boolean} visible_accueil - L'article est visible sur l'accueil du module
 * @prop {int} quantite - Quantite de l'article
 * @class Activite
 */
export default class Article_Boutique {
    id = "";
    id_module = "";
    nom = "";
    description = "";
    prix = "";
    obligatoire = 0;
    date_max = "";
    url_image = "";
    url_image_2 = "";
    url_image_3 = "";
    visible_accueil = 1;
    quantite = 0;
    quantite_souhaite = 0;
    nb_reservations = 0;
    quantite_restante = 0;
    metadatas = [];
    sizes = [];


    /**
     * Crée un article
     * @constructs
     * @kind function
     * @memberof Article_Boutique
     */
    constructor() { }

    /**
     * Défini un article à partir d'un jeu de données
     *
     * @param {Object} data
     * @memberof Article_Boutique
     */
    set(data) {
        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                // Cloner les tableaux et objets pour éviter le partage de références
                if (Array.isArray(value)) {
                    this[key] = value.map(item => {
                        if (typeof item === 'object' && item !== null) {
                            return { ...item };
                        }
                        return item;
                    });
                } else if (typeof value === 'object' && value !== null) {
                    this[key] = { ...value };
                } else {
                    this[key] = value;
                }
            }
        }
        this.set_desired_quantity_per_size();
    }

    set_desired_quantity_per_size() {
        this.sizes.forEach(size => {
            if (size.quantite_souhaite == undefined) {
                size.quantite_souhaite = 0;
            }

            size.quantite_max = Math.min(10, size.quantite_restante);


        });
    }


    update_cart(lien_groupe = null) {
        let cart = { nb_articles: 0, prix: 0, prix_regulier: 0 };
        cart.nb_articles = parseInt(this.quantite_souhaite);
        const prix_normal = parseInt(this.quantite_souhaite) * parseInt(this.prix);
        cart.prix_regulier = prix_normal;
        cart.prix = prix_normal;
        if (lien_groupe && !lien_groupe.doit_payer_options) {
            cart.prix = 0;
        }
        this.current_price = cart.prix;
        this.cart = cart;
        return cart;
    }

    is_selectionnable(statut_ouverture_module, admin_view, admin_ins, lien_groupe = null) {
        if (lien_groupe && lien_groupe?.is_lien_groupe && (statut_ouverture_module == 'ouverte' || (statut_ouverture_module == 'avant_ouverture' && lien_groupe.allow_before_opening))) {
            const is_complet = this.is_complet();
            const inscriptions_options_completes = lien_groupe.inscriptions_options_completes;
            if (inscriptions_options_completes) {
                return true;
            }
            return !is_complet;
        }

        if (statut_ouverture_module == 'ouverte') {
            return true;
        }
        if (admin_view && !this.is_complet()) {
            return true;
        }
        if (admin_ins) {
            return true;
        }

        return false;
    }

    is_complet() {
        if (this.quantite_restante == 0) {
            return true;
        }
        return false;
    }


    get_metadata(key) {
        for (let i = 0; i < this.metadatas.length; i++) {
            if (this.metadatas[i].nom == key) {
                return this.metadatas[i].valeur;
            }
        }
        return false;
    }

    getSimplifiedData() {
        if (this.quantite_souhaite == 0) return null;
        const infos = {};
        infos.prix = this?.cart?.prix;
        infos.quantite = this.quantite_souhaite;
        infos.id = this.id;
        infos.nom = this.nom;
        return infos;
    }



}
